/* Helper to extract the first user-msg text from a keypress scenario.
   Used by all page-level keypress handlers so they can feed the text
   into the chat-input typing animation before opening the chat panel. */
export const getFirstUserMsg = (scenarios, key) => {
  const scenario = scenarios?.[key];
  if (!scenario?.events) return '';
  const firstUserEvent = scenario.events.find((ev) => ev?.type === 'user-msg');
  return firstUserEvent?.text || '';
};
